import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@chatterbug/aaron'

const NextActivitiesSkeleton = ({
  headerSection,
  listSection,
  buttonSection,
}) => {
  return (
    <Grid gridGap="1x">
      {headerSection}
      {listSection}
      {buttonSection}
    </Grid>
  )
}

NextActivitiesSkeleton.propTypes = {
  headerSection: PropTypes.any,
  listSection: PropTypes.any,
  buttonSection: PropTypes.any,
}

export default NextActivitiesSkeleton
